<template lang="pug">
  .component-selectize-vehicle-slot
    //pre {{ites}}
    selectize(v-if="options", :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Vehicle slot")
</template>

<script>
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
  import BaseSelectize from './BaseSelectize'
  import Selectize from "../../../Selectize";

  export default {
    name: "SelectizeAvailableVehicleSlot",
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: [
          'id',
          'name',
          'brand',
          'model',
          'plate',
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.vehicleSlots.list().available((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        var template = '';
        template += '<div>'
        template += `<div><small><i class="fa fa-car"></i>V${item.id}</small></div>`
        template += `<div>${item.brand} ${item.model}<br><small>${item.plate}</small></div>`
        template += '</div>'

        return template
      },
      renderTemplate(item, escape) {
        return `<div>${item.brand} ${item.model}<br><small>${item.plate}</small></div>`
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeAvailableVehicleSlot.vue?ee615d9e